import { Alert } from 'antd';
import { IWorkDiff } from 'models';
import { userStore } from 'stores';

interface HistoryBlockProps {
	title: string;
	list: IWorkDiff[];
	type: 'success' | 'info' | 'warning' | 'error';
}

export const HistoryBlock = ({ list, title, type }: HistoryBlockProps) => {
	return (
		<Alert type={type} title={title} description={list.map((el, i) => {
			return (
				<div key={`${el.label}_${i}`}>
					<b>{el.label}:</b> {el.label === 'Worker' ? userStore.getUser(+el.value)?.name : el.value.toString()}
				</div>
			);
		})} />
	);
};